module.exports = __webpack_public_path__ + "img/gap.85355145.jpg";